module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/thumbs/12-fa5f3446c51044962af9c630ff5fb59c.webp";